import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { SourcingRequestEntity } from './sourcing-request.entity';

@Index('idx_srn_sr', ['fkSourcingRequestId'], {})
@Entity('sourcing_request_note')
export class SourcingRequestNoteEntity extends BaseEntity {
	@Column('int', { name: '_fk_sourcing_request__id', unsigned: true })
	public fkSourcingRequestId!: number;

	@Column('text', { name: 'text' })
	public text!: string;

	@Column({ type: 'boolean', name: 'is_pinned', width: 1, default: 0 })
	public isPinned!: boolean;

	@ManyToOne(() => SourcingRequestEntity, (request) => request.notes_, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: '_fk_sourcing_request__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequest!: SourcingRequestEntity;
}
